import { useState } from 'react'
import styled from '@emotion/styled'
import { Widget } from '@uploadcare/react-widget'
import { imageValidators } from '../lib/validators'
import Button, { common, smallRules } from './Button'

const Container = styled.div`
  align-items: flex-start;
  display: flex;

  .uploadcare--widget__button_type_open {
    ${common}
    ${smallRules}
    background-color: ${({ theme }) => theme.colors.blue};
    color: ${({ theme }) => theme.colors.background};

    &:hover:enabled,
    &:focus {
      box-shadow: ${({ theme }) => theme.colors.blueBoxShadow} 0px 0px 0px 4px;
    }
  }

  .uploadcare--widget__button_type_remove {
    ${common}
    ${smallRules}
    background-color: ${({ theme }) => theme.colors.gray};
    color: ${({ theme }) => theme.colors.background};

    &:hover:enabled,
    &:focus {
      box-shadow: ${({ theme }) => theme.colors.grayBoxShadow} 0px 0px 0px 4px;
    }
  }

  .uploadcare--widget__text {
    ${smallRules}
    border-color: ${({ theme }) => theme.colors.background};
    border-style: solid;
    border-radius: 0.125rem;
    border-width: 2px;
    padding: 0.38rem 1rem;
  }
`

const ImageUpload = ({ className, crop, onChange, value }) => {
  const [showRemove, setShowRemove] = useState(!!value)

  const handleChange = (file) => {
    setShowRemove(false)
    onChange(file)
  }

  return (
    <Container className={className}>
      <Widget
        clearable
        crop={crop}
        onChange={handleChange}
        onFileSelect={(file) => {
          if (file === null) handleChange({ cdnUrl: null })
        }}
        previewStep
        publicKey={process.env.NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY}
        tabs="file url camera"
        validators={imageValidators}
      />

      {showRemove && (
        <Button
          className="ml2"
          secondary
          small
          onClick={() => handleChange({ cdnUrl: null })}
        >
          Remove
        </Button>
      )}
    </Container>
  )
}

export default ImageUpload
